import { css, useTheme } from "@emotion/react"
import React from "react"
import { Flex } from "rebass"

const textContainer = css`
  flex-direction: column;
  align-items: space-between;
  gap: 8px;
  width: 100%;
`

type Props = {
  Title: JSX.Element
  Right?: JSX.Element
  type?: "choose" | "none" | "loading" | "remove"
  onClick?: () => void
  Left?: JSX.Element
  Subtitle?: JSX.Element
}

export const LIST_ITEM_HEIGHT = 58

export const ListItem = ({
  Title,
  Right,
  type,
  onClick,
  Left,
  Subtitle,
}: Props) => {
  const theme = useTheme()

  const itemContainerStyle = css`
    width: 100%;
    flex-direction: column;
    border-radius: 4px;
    ${type === "choose" &&
    `
      &:hover {
        background-color: ${theme.colors.ctaLight};
      }
    `}
  `

  const itemBaseStyle = css`
    flex-direction: row;
    height: ${LIST_ITEM_HEIGHT}px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    cursor: ${type === "choose" ? "pointer" : "regular"};
    ${theme.bp.desktop} {
      padding: 16px;
      gap: 16px;
    }
    ${theme.bp.mobile} {
      padding: 8px;
      gap: 2px;
    }
  `

  const leftContainerStyle = css`
    display: flex;
    width: 100%;
    align-items: center;
    ${theme.bp.desktop} {
      gap: 16px;
    }
    ${theme.bp.mobile} {
      gap: 12px;
    }
  `

  const itemStyle = css`
    color: ${theme.colors.ctaMain};
    .choose-button {
      visibility: ${type === "choose" && "hidden"};
    }
    &:hover > .choose-button {
      visibility: ${type === "choose" && "visible"};
      min-width: auto;
    }
  `

  const imageWrapperStyle = css`
    ${type === "none" ? "opacity: 0.5" : "opacity: 1"}
  `

  return (
    <Flex css={itemContainerStyle}>
      <Flex
        onClick={() => type === "choose" && onClick && onClick()}
        css={[itemBaseStyle, itemStyle]}
      >
        <Flex css={leftContainerStyle}>
          {Left && <div css={imageWrapperStyle}>{Left}</div>}
          <Flex css={textContainer}>
            {Title}
            {Subtitle}
          </Flex>
        </Flex>
        {Right}
      </Flex>
    </Flex>
  )
}
